import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Advertiser } from '../../../models/admModel/account.model';
import * as config from '../backend.config';

// ----------------------------------------------
// Service for Publisher / Stats
// Component:
// ----------------------------------------------

const ADDRS_API = config.API;
const FILTER_KEY1 = 'filter-pub-stat-country-start';
const FILTER_KEY2 = 'filter-pub-stat-country-end';
const FILTER_KEY3 = 'filter-pub-stat-country-button';
const FILTER_KEY4 = 'filter-pub-stat-country-page';

const FILTER_KEY5 = 'filter-pub-stat-countent-start';
const FILTER_KEY6 = 'filter-pub-stat-countent-end';
const FILTER_KEY7 = 'filter-pub-stat-countent-button';
const FILTER_KEY8 = 'filter-pub-stat-countent-page';

const FILTER_KEY10 = 'filter-pub-stat-conver-status';
const FILTER_KEY11 = 'filter-pub-stat-conver-country';
const FILTER_KEY12 = 'filter-pub-stat-conver-start';
const FILTER_KEY13 = 'filter-pub-stat-conver-end';
const FILTER_KEY14 = 'filter-pub-stat-conver-button';
const FILTER_KEY15 = 'filter-pub-stat-conver-page';

// API description for all commnication with BACK-END for accounts management
// ----------------------------------------------
// BACK-END API
// ----------------------------------------------
//  Method    URLS                      Actions                     View
//  GET       api/pub/char/:id          dane do wykresu             http://localhost:4200/pub/dashboard
//  GET       api/pub/lconv/:id         dane do tabeli last conversions

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})

export class StatsService {
  constructor(private http: HttpClient) { }

  getConversions(data: any): Observable<any> {
    return this.http.post(ADDRS_API + `/publishers/stats/conversions`, data);
  }

  getContents(data: any): Observable<any> {
    return this.http.post(ADDRS_API + `/publishers/stats/content-lockers`, data);
  }

  getCountries(data: any): Observable<any> {
    return this.http.post(ADDRS_API + `/publishers/stats/countries`, data);
  }

  getLiveVisitors(): Observable<any> {
    return this.http.get(ADDRS_API + `/publishers/stats/live-visitors-map`);
  }

  getAnalytics(data: any): Observable<any> {
    return this.http.post(ADDRS_API + `/publishers/stats/analytics`, data);
  }

  getAnalyticsCountryOffers(data: any): Observable<any> {
    return this.http.post(ADDRS_API + `/publishers/stats/analytics/offers`, data);
  }

  getAnalyticsPie(data: any): Observable<any> {
    return this.http.post(ADDRS_API + `/publishers/stats/analytics/pie-chart`, data);
  }

  getAnalyticsGlobe(data: any): Observable<any> {
    return this.http.post(ADDRS_API + `/publishers/stats/analytics/worldwide-chart`, data);
  }

  getAnalyticsGrid(data: any): Observable<any> {
    return this.http.post(ADDRS_API + `/publishers/stats/analytics/grid-data`, data);
  }

  // ----------------------------------------------
  // OBSŁUGA FILTRÓW
  // PUBLISHER-STATS

  public saveFilter(id: number, filter: any): void {
    switch(id){
      case 1: // filtr start date - countries
        window.sessionStorage.removeItem(FILTER_KEY1);
        window.sessionStorage.setItem(FILTER_KEY1, JSON.stringify(filter));
        break;

      case 2: // filtr end date - countries
        window.sessionStorage.removeItem(FILTER_KEY2);
        window.sessionStorage.setItem(FILTER_KEY2, JSON.stringify(filter));
        break;

      case 3: // button - countries
        window.sessionStorage.removeItem(FILTER_KEY3);
        window.sessionStorage.setItem(FILTER_KEY3, JSON.stringify(filter));
        break;

      case 4: // page - countries
        window.sessionStorage.removeItem(FILTER_KEY4);
        window.sessionStorage.setItem(FILTER_KEY4, JSON.stringify(filter));
        break;

      // ----------------------------------
      case 5: // filtr start date - contents
        window.sessionStorage.removeItem(FILTER_KEY5);
        window.sessionStorage.setItem(FILTER_KEY5, JSON.stringify(filter));
        break;

      case 6: // filtr end date - contents
        window.sessionStorage.removeItem(FILTER_KEY6);
        window.sessionStorage.setItem(FILTER_KEY6, JSON.stringify(filter));
        break;

      case 7: // button - contents
        window.sessionStorage.removeItem(FILTER_KEY7);
        window.sessionStorage.setItem(FILTER_KEY7, JSON.stringify(filter));
        break;

      case 8: // page - contents
        window.sessionStorage.removeItem(FILTER_KEY8);
        window.sessionStorage.setItem(FILTER_KEY8, JSON.stringify(filter));
        break;

      // ----------------------------------
      case 10: // filtr status - convert
        window.sessionStorage.removeItem(FILTER_KEY10);
        window.sessionStorage.setItem(FILTER_KEY10, JSON.stringify(filter));
        break;

      case 11: // filtr country - convert
        window.sessionStorage.removeItem(FILTER_KEY11);
        window.sessionStorage.setItem(FILTER_KEY11, JSON.stringify(filter));
        break;

      case 12: // filter start date - convert
        window.sessionStorage.removeItem(FILTER_KEY12);
        window.sessionStorage.setItem(FILTER_KEY12, JSON.stringify(filter));
        break;

      case 13: // filter end date - convert
        window.sessionStorage.removeItem(FILTER_KEY13);
        window.sessionStorage.setItem(FILTER_KEY13, JSON.stringify(filter));
        break;

      case 14: // button - convert
        window.sessionStorage.removeItem(FILTER_KEY14);
        window.sessionStorage.setItem(FILTER_KEY14, JSON.stringify(filter));
        break;

      case 15: // page - convert
        window.sessionStorage.removeItem(FILTER_KEY15);
        window.sessionStorage.setItem(FILTER_KEY15, JSON.stringify(filter));
        break;

      }
    }

    public getFilter(id: number): any {
      switch(id) {
        case 1: // filtr start date - countries
          const filter1 = window.sessionStorage.getItem(FILTER_KEY1);
          if(filter1)
          {
            return JSON.parse(filter1);
          }
          return null;

        case 2: // filtr end
          const filter2 = window.sessionStorage.getItem(FILTER_KEY2);
          if(filter2)
          {
            return JSON.parse(filter2);
          }
          return null;

        case 3: // button on/off
          const filter3 = window.sessionStorage.getItem(FILTER_KEY3);
          if(filter3)
          {
            return JSON.parse(filter3);
          }
          return null;

        case 4: // page
          const filter4 = window.sessionStorage.getItem(FILTER_KEY4);
          if(filter4)
          {
            return JSON.parse(filter4);
          }
          return null;

        // ---------------------------
        case 5: // filtr start date - contents
          const filter5 = window.sessionStorage.getItem(FILTER_KEY5);
          if(filter5)
          {
            return JSON.parse(filter5);
          }
          return null;

        case 6: // filtr end - contents
          const filter6 = window.sessionStorage.getItem(FILTER_KEY6);
          if(filter6)
          {
            return JSON.parse(filter6);
          }
          return null;

        case 7: // button on/off - contents
          const filter7 = window.sessionStorage.getItem(FILTER_KEY7);
          if(filter7)
          {
            return JSON.parse(filter7);
          }
          return null;

        case 8: // page - contents
          const filter8 = window.sessionStorage.getItem(FILTER_KEY8);
          if(filter8)
          {
            return JSON.parse(filter8);
          }
          return null;

        // ---------------------------
        case 10: //
          const filter10 = window.sessionStorage.getItem(FILTER_KEY10);
          if(filter10)
          {
            return JSON.parse(filter10);
          }
          return null;

        case 11: //
          const filter11 = window.sessionStorage.getItem(FILTER_KEY11);
          if(filter11)
          {
            return JSON.parse(filter11);
          }
          return null;

        case 12: //
          const filter12 = window.sessionStorage.getItem(FILTER_KEY12);
          if(filter12)
          {
            return JSON.parse(filter12);
          }
          return null;

        case 13: //
          const filter13 = window.sessionStorage.getItem(FILTER_KEY13);
          if(filter13)
          {
            return JSON.parse(filter13);
          }
          return null;

        case 14: //
          const filter14 = window.sessionStorage.getItem(FILTER_KEY14);
          if(filter14)
          {
            return JSON.parse(filter14);
          }
          return null;

        case 15: //
          const filter15 = window.sessionStorage.getItem(FILTER_KEY15);
          if(filter15)
          {
            return JSON.parse(filter15);
          }
          return null;
      }
    }


}
